import './class-component-custom-hooks';
import Vue from 'vue';
import {i18n} from '@/plugins/i18n';
import App from './App.vue';
import router from '@/setup/router/router';
import vuetify from '@/plugins/vuetify';
import InstanceProvided from '@/core/globalInjectionSystem/GlobalInjection';
import './setup/filters';
import VTextFieldOutlined from '@/components/Shared/VTextFieldOutlined.vue';
import VTextAreaOutlined from '@/components/Shared/VTextAreaOutlined.vue';
import VSelectOutlined from '@/components/Shared/VSelectOutlined.vue';
import convert from './plugins/UnitConverter';
import './setup/momentConfig';

Vue.config.productionTip = false;
Vue.component('VTextFieldOutlined', VTextFieldOutlined);
Vue.component('VTextAreaOutlined', VTextAreaOutlined);
Vue.component('VSelectOutlined', VSelectOutlined);
Vue.use(convert);
Vue.prototype.$drawer = Vue.observable({status: false});
const vueInstance = new InstanceProvided({
  router,
  vuetify,
  i18n,
  render: (h) => h(App),
}).$mount('#app');

Object.assign(window, {__vm: vueInstance});

export default vueInstance;
